// extracted by mini-css-extract-plugin
export default {"magicLinkStep":"MagicLink_magicLinkStep__wQdp8","helper":"MagicLink_helper__xh8ht","sentTo":"MagicLink_sentTo__Y7lJ-","btnRow":"MagicLink_btnRow__8V2rE"};